import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { ThemeTag } from '../Tags/ThemeTag';

const ThemePublicationHeaderWrapper = styled.div`
  margin: 0px -7px;
`;

const ThemeTagWrapper = styled.span`
  margin: 0 8px;
`;

export const ThemePublicationHeader = ({ subThemes }) => {
  const showSubthemes = subThemes && subThemes.length !== 0;
  if (!showSubthemes) return null;
  const {
    color,
    colorHover,
    colorActive,
    colorVisited,
    slug,
    parentSlug,
    name,
  } = subThemes[0];

  return (
    <ThemePublicationHeaderWrapper>
      <ThemeTagWrapper>
        <ThemeTag
          color={color}
          colorHover={colorHover}
          colorActive={colorActive}
          colorVisited={colorVisited}
          href={`/thema/${parentSlug}/${slug}`}
        >
          {name}
        </ThemeTag>
      </ThemeTagWrapper>
    </ThemePublicationHeaderWrapper>
  );
};

ThemePublicationHeader.propTypes = {
  subThemes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      slug: PropTypes.string,
      color: PropTypes.string,
      colorHover: PropTypes.string,
      colorActive: PropTypes.string,
      colorVisited: PropTypes.string,
      backgroundImageUrl: PropTypes.string,
      backgroundImageMobileUrl: PropTypes.string,
      parentSlug: PropTypes.string,
      parent: {
        id: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string,
        slug: PropTypes.string,
        color: PropTypes.string,
        colorHover: PropTypes.string,
        colorActive: PropTypes.string,
        colorVisited: PropTypes.string,
        backgroundImageUrl: PropTypes.string,
        backgroundImageMobileUrl: PropTypes.string,
      },
    })
  ),
};

export default ThemePublicationHeader;
